export default __webpack_public_path__ + "static/media/logo.ff37da86.png";